import angular from 'angular'

import BannerService       from './banner/banner.service'
import BufferFactory       from './common/buffer.factory'
import CountriesService    from './countries/countries.service'
import DeviceService       from './device/device.service'
import HelpersService      from './common/helpers.service'
import IdsService          from './ids/ids.service'
import PaymentService      from './payment/payment.service'
import ProductService      from './product/product.service'
import ProductUtilsService from './product/product-utils.service'
import RegistrationService from './registration/registration.service'
import SubscriptionService from './subscription/subscription.service'
import UserService         from './user/user.service'
import VehicleService      from './vehicle/vehicle.service'
import VoucherService      from './voucher/voucher.service'
import VoucherFactory      from './voucher/voucher.factory'
import MetricsService      from './metrics/metrics.service'
import SDFilterService     from './sdfilter/sdfilter.service'
import DocumentsService    from './documents/documents.service'
import CookiesService      from './cookies/cookies.service'

let module = angular.module('services', [])
.service('BannerService', BannerService)
.factory('BufferFactory', BufferFactory)
.service('CountriesService', CountriesService)
.service('DeviceService', DeviceService)
.service('HelpersService', HelpersService)
.service('IdsService', IdsService)
.service('PaymentService', PaymentService)
.service('ProductService', ProductService)
.service('ProductUtilsService', ProductUtilsService)
.service('RegistrationService', RegistrationService)
.service('SubscriptionService', SubscriptionService)
.service('UserService', UserService)
.service('VehicleService', VehicleService)
.factory('VoucherFactory', VoucherFactory)
.service('VoucherService', VoucherService)
.service('MetricsService', MetricsService)
.service('SDFilterService', SDFilterService)
.service('DocumentsService', DocumentsService)
.service('CookiesService', CookiesService)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/services/index.js